












import Vue from 'vue'
export default Vue.extend({
  computed: {
    wrappedValue: {
      get(): any {
        return this.value
      },
      set(value: any) {
        this.$emit('input', value)
      },
    },
  },
  props: {
    value: {
      type: [String, Number],
    },
    variable: {
      type: String,
    },
    description: {
      type: String,
    },
    numeric: {
      default: () => false,
      type: Boolean,
    },
    rows: {
      default: () => 1,
      type: Number,
      validator: (value: Number) => value >= 1,
    },
  },
})
